import { fork, cls } from '@mssgme/helpers';
import styles from './Fieldset.scss';

const Fieldset = fork('fieldset', cls(styles.root));
Fieldset.displayName = 'Fieldset';

export default Fieldset;
